import RedeemActions from '../actions/RedeemActions';
import Url from '../constants/Url';
import axios from 'axios';
import {getLocale} from '@epic-core/common';
import root from 'window-or-global';

/**
 * RedeemSource
 *
 * Ajax calls for Orion code redemption data
 *
 * For more information on source usage:
 * http://alt.js.org/docs/async/
 *
 */

const xhr = {
  getHeader() {
    return {
      'X-Requested-With': 'XMLHttpRequest',
      'X-EPIC-RETURN-JSON-IF-NO-AUTH': true,
      'Accept-Language': getLocale(),
    };
  },
  postHeader() {
    return {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept-Language': getLocale(),
    };
  },
};

const RedeemSource = {
  validateCode: {
    remote(state) {
      return axios({
        headers: xhr.postHeader(),
        method: 'post',
        url: Url().REDEEM.VALIDATE,
        data: `codeId=${encodeURIComponent(state.redeemCode)}&captchaToken=${
          state.captchaToken
        }&locale=${encodeURIComponent(getLocale())}`,
      });
    },
    success: RedeemActions.validateCodeSuccess,
    error: RedeemActions.validateCodeFailure,
    shouldFetch() {
      return !root.__server_side_render;
    },
  },
  redeemCode: {
    remote(state, data) {
      return axios({
        headers: xhr.postHeader(),
        method: 'post',
        url: Url().REDEEM.SUBMIT,
        data: `hostPageId=${encodeURIComponent(data.hostPageId)}&codeId=${encodeURIComponent(
          data.redeemCode
        )}&captchaToken=${state.captchaToken}&locale=${encodeURIComponent(getLocale())}`,
      });
    },
    success: RedeemActions.redeemCodeSuccess,
    error: RedeemActions.redeemCodeFailure,
    shouldFetch() {
      return !root.__server_side_render;
    },
  },
  clearEntitlementsFromSession: {
    remote() {
      return axios.get(Url().REDEEM.CLEARENTITLEMENTS);
    },
    success: RedeemActions.clearEntitlementsFromSessionSuccess,
    error: RedeemActions.clearEntitlementsFromSessionFailure,
    shouldFetch() {
      return !root.__server_side_render;
    },
  },
};

export default RedeemSource;
